import { useMutation } from '@tanstack/react-query'

import { updateFreeeJournaling } from '@src/api'
import { DefaultApiUpdateFreeeJournalingRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

export const useUpdateFreeeJournaling = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: (params: DefaultApiUpdateFreeeJournalingRequest) =>
      updateFreeeJournaling(axiosInstance, params),
  })
}
